import { useInitializeProducts } from "@/stores/products";

/**
 * Component that initializes products data when mounted.
 * Should be rendered when user is authenticated.
 */
export const ProductsInitializer = () => {
  useInitializeProducts();
  return null;
};
